<script>
    export let topic;
</script>

<style>
    label {
        font-weight: 400;
    }
</style>

<svelte:options immutable={true}/>

<label title={topic.title}>
    <input type="checkbox" bind:checked={topic.checked} on:change>
    { topic.title }
</label>
